export default __webpack_public_path__ + "files/Flandes_PositionPaperBioeconomy.docx";